/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Components/SimpleMarkdownRenderer" />
import * as React from "react";

import * as MarkdownIt from "markdown-it";
import * as HtmlNormalizer from "VSS/Features/Markdown/Utils/HtmlNormalizer";

export interface ISimpleMarkdownRendererProps {
    text: string;
}

export interface ISimpleMarkdownRendererState {
    content?: string;
}

export class SimpleMarkdownRenderer extends React.Component<ISimpleMarkdownRendererProps, ISimpleMarkdownRendererState> {
    private _renderer: MarkdownIt.MarkdownIt;

    public constructor(props: ISimpleMarkdownRendererProps, state: ISimpleMarkdownRendererState) {
        super(props, state);

        this.state = {};

        this._renderer = new MarkdownIt({
            breaks: true,
            linkify: false,
            typographer: false,
            html: true
        });

        this._renderer.validateLink = validateLinkProtocol;
    }

    public render() {
        const content = this._renderer.render(this.props.text);
        return <span dangerouslySetInnerHTML={{__html: content}} />;
    }
}

const BAD_PROTOCOLS = /^(vbscript|javascript|file|data):/;
export function validateLinkProtocol(url: string) {
    var str = url.trim().toLowerCase();
    return !BAD_PROTOCOLS.test(str);
}
